export default {
  RECORD: 'record',
  CATALOG: 'catalog',
  RECORDS_BATCH_UPDATE: 'records_batch_update',
  RECORDS_BATCH_DELETE: 'records_batch_delete',
};
